module.exports = __webpack_public_path__ + "img/uploadd.3a066ca3.png";